import { notificationsCenterTabs } from 'constants/notifications';
import { operatingCountries } from 'constants/user';

/**
 * Evaluate whether a given notification falls under given tab
 * Notification attribute 'subCategory' is used to determine
 * @param {*} notification
 * @param {*} tab
 * @returns
 */
const isNotificationInTab = (notification, tab) => {
  return tab.key === 'ALL' || tab.key === notification.subCategory;
};

/**
 * Evaluate whether a given notification attribute contain the search text
 * @param {*} attribute
 * @param {*} searchText
 * @returns
 */
const isAttributeMatched = (attribute, searchText) => {
  const searchTextUpper = searchText.toUpperCase();
  return !!attribute && attribute.toUpperCase().includes(searchTextUpper);
};

/**
 * Evaluate whether a given notification is matched to a search text
 * If search text is empty return true
 * @param {*} notification
 * @param {*} searchText
 * @returns
 */
const isSearchMatched = (notification, searchText) => {
  return !searchText || isAttributeMatched(notification.heading, searchText) ||
    isAttributeMatched(notification.subheading, searchText) ||
    isAttributeMatched(notification.body, searchText);
};

/**
 * Filter notifications from the tab and search text
 * @param {*} notifications
 * @param {*} tab notification center tab
 * @param {*} searchText
 * @returns filtered notifications
 */
export const getFilteredNotifications = (notifications, tab, searchText) => {
  return notifications.filter(notification => {
    return isNotificationInTab(notification, tab) && isSearchMatched(notification, searchText);
  });
};

/**
 * Filters the allowed tab headers based on the user account country
 * @param {String} userCountry country of the user account eg: 'USA', 'CANADA'
 * @returns filtered tab-header list
 */
 export const getAllowedTabList = (userCountry = operatingCountries.unitedStates) => {
  const notificationsCenterTabList = Object.values(notificationsCenterTabs);
    return userCountry === operatingCountries.canada ? notificationsCenterTabList.filter(tab => !tab.isCanadaRestricted) : notificationsCenterTabList;
}